import React from "react";
import { useTranslation } from "react-i18next";

function clampScore(v) {
  const n = parseInt(v, 10);
  if (Number.isNaN(n)) return 0;
  return Math.max(0, Math.min(20, n));
}

const FirstLegInput = ({ home, away, onHome, onAway, homeColor, awayColor }) => {
  const { t } = useTranslation();
  const homeName = t("scoring.team.home");
  const awayName = t("scoring.team.away");

  return (
    <div className="scoring-firstleg">
      <div className="scoring-firstleg__title">{t("scoring.firstLeg.title")}</div>
      <div className="scoring-firstleg__hint">{t("scoring.firstLeg.hint")}</div>
      <div className="scoring-firstleg__row">
        <div className="scoring-firstleg__team">
          <span className="scoring-firstleg__dot" style={{ background: homeColor }} />
          <span>{homeName}</span>
        </div>
        <input
          type="number"
          className="scoring-firstleg__input"
          value={home}
          onChange={(e) => onHome(clampScore(e.target.value))}
          min="0"
          max="20"
        />
        <span className="scoring-firstleg__colon">:</span>
        <input
          type="number"
          className="scoring-firstleg__input"
          value={away}
          onChange={(e) => onAway(clampScore(e.target.value))}
          min="0"
          max="20"
        />
        <div className="scoring-firstleg__team scoring-firstleg__team--right">
          <span>{awayName}</span>
          <span className="scoring-firstleg__dot" style={{ background: awayColor }} />
        </div>
      </div>
    </div>
  );
};

export default FirstLegInput;
